module.exports = __webpack_public_path__ + "static/media/13-iveco-mercedes.d0c84fcc.jpg";